export default "__VITE_ASSET__CqB2UdKq__"